__turbopack_context__.v({
  "chip": "category-filters-module-scss-module__mf0FWa__chip",
  "chips": "category-filters-module-scss-module__mf0FWa__chips",
  "filters": "category-filters-module-scss-module__mf0FWa__filters",
  "label": "category-filters-module-scss-module__mf0FWa__label",
  "note": "category-filters-module-scss-module__mf0FWa__note",
});
